enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  FORGOT_FIRST_PASSWORD = "forgotFirstPassword",
  VERIFY_TOKEN_PASSWORD = "verifyTokenPassword",
  UPDATE_PASSWORD = "updatePassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  GET_FACTURAS_DASHBOARD = "getFacturasDashboard",
  GET_FACTURAS_REFERENCIA = "getFacturasReferencia",
  GET_FACTURAS = "getFacturas",
  GET_PROVEEDORES = "getProveedores",
  GET_PROVEEDOR = "getProveedor",
  GET_PROVEEDOR_RUT = "getProveedorRut",
  UPD_PROVEEDOR = "updateProveedor",
  CREATE_SOLICITUD_PROVEEDOR = "createSolicitudProveedor",
  UPD_EMAIL_PROVEEDOR = "updateEmailProveedor",
  UPD_CONTRASENA_PROVEEDOR = "updateContrasenaProveedor",
  GET_EMPRESAS = "getEmpresas",
  GET_SOLICITUDES = "getSolicitudes",
  GET_SOLICITUD = "getSolicitud",
  UPD_SOLICITUD = "updateSolicitud",
  UPD_SOLICITUDES = "updateSolicitudes",
  INS_SOLICITUD = "createSolicitud",
  DEL_SOLICITUD = "deleteSolicitud",
  GET_USUARIOS = "getUsuarios",
  GET_USUARIOS_ADMINISTRADORES = "getUsuariosAdministradores",
  GET_USUARIO = "getUsuario",
  UPD_USUARIO = "updateUsuario",
  UPD_USUARIO_DATOS_BASE = "updateUsuariodatosBase",
  UPD_USUARIO_UP = "updateUsuarioUp",
  UPD_USUARIO_DOWN = "updateUsuarioDown",
  UPD_CONTRASENA_USUARIO = "updateContrasenaUsuario",
  UPD_RESETEO_CONTRASENA_USUARIO = "updateReseteoContrasenaUsuario",
  INS_USUARIO = "createUsuario",
  INS_USUARIO_ADMINISTRADOR = "createUsuarioAdministrador",
  DEL_USUARIO = "deleteUsuario",
  GET_TICKETES = "getTicketes",
  GET_TICKETES_NOTIFICACIONES = "getTicketesNotifications",
  GET_TICKETES_MIS_TICKETS = "getMisTicketes",
  GET_TICKET = "getTicket",
  UPD_TICKET = "updateTicket",
  UPD_RESP_TICKET = "updateRespuestaTicket",
  UPD_LEIDO_TICKET = "updateLeidoTicket",
  INS_TICKET = "createTicket",
  DEL_TICKET = "deleteTicket",
  GET_GROUPS = "getGroups",
  DELETE_GROUPS = "deleteGroups",
  CREATE_GROUP = "createGroup",
  EDIT_GROUP = "editGroup",
  GET_PROVEEDORES_GRUPO = "getProveedoresGrupo",
  UPLOAD_FILE = "uploadFile",
  GET_UPLOADS = "getUploads",
  GET_UPLOADS_ID = "getUploadsId",
  UPDATE_FILE = "updateFile",
  UPDATE_FILE_GRUPO = "updateFileGrupo",
  CREATE_LINKS = "createLinks",
  GET_LINKS = "getLinks",
  GET_LINKS_ID = "getLinksId",
  UPDATE_LINKS = "updateLinks",
  UPDATE_LINKS_GRUPO = "updateLinksGrupo",
  DELETE_LINKS = "deleteLinks",

  GET_LICITACIONES = "getLicitaciones",
  GET_NOTICIAS = "getNoticias",
  GET_NOTICIA = "getNoticia",
  DELETE_NOTICIA = "deleteNoticia",
  CREATE_NOTICIA = "createNoticia",
  EDIT_NOTICIA = "editNoticia",

  CREATE_LICITANTE = "createLicitante",
  GET_LICITANTE = "getLicitante",
  UPDATE_PENDIENTE_LICITANTE = "updatePendienteLicitante",
  UPDATE_RECHAZAR_LICITANTE = "updateRechazarPendiente",
  GET_LICITACIONES_LICITANTE = "getLicitacionesLicitante",
  CREATE_AYUDA = "createAyuda",
  DELETE_LICITACIONES = "deleteLicitaciones",
  CREATE_LICITACION = "createLicitacion",
  EDIT_LICITACION = "editLicitacion",

  GET_BANCOS = "getBancos",
  CREATE_LINK_DOCUMENTO = "createLinkDocumento",
  GET_LINK_DOCUMENTOS = "getLinkDocumentos",
  GET_LINK_DOCUMENTO_ID = "getLinkDocumentoId",
  DESCARGAR_LINK_DOCUMENTO = "descargarLinkDocumento",
  SUBIR_DOCUMENTO_BANCO = "subirDocumentoBanco",
  DESCARGAR_DOCUMENTO_BANCO = "descargarDocumentoBanco",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  SET_FACTURA_DASHBOARD = "setFacturaDashboard",
  SET_FACTURA = "setFactura",
  SET_FACTURAS = "setFacturas",
  SET_PROVEEDOR = "setProveedor",
  SET_PROVEEDORES = "setProveedores",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_USER_PASS = "setUserPass",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_AUTH_ERROR = "setError",
  SET_FACTURA_ERROR = "setFacturaError",
  SET_PROVEEDOR_ERROR = "setProveedorError",
  SET_SOLICITUD = "setSolicitud",
  SET_SOLICITUDES = "setSolicitudes",
  SET_SOLICITUD_ERROR = "setSolicitudError",
  SET_USUARIO = "setUsuario",
  SET_USUARIOS = "setUsuarios",
  SET_USUARIO_ERROR = "setUsuarioError",
  SET_TICKET = "setTicket",
  SET_TICKETES = "setTicketes",
  SET_TICKETES_NOTIFICACIONES = "setTicketesNotificaciones",
  SET_MIS_TICKETES = "setTicketesMios",
  SET_TICKET_ERROR = "setTicketError",
  SET_EMPRESAS = "setEmpresas",
  SET_EMPRESA_ERROR = "setEmpresaError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",

  SET_GROUP = "setGroup",
  SET_GROUPS = "setGroups",
  SET_GROUP_ERROR = "setGroupError",

  SET_UPLOAD_ERROR = "setUploadError",
  SET_UPLOAD = "setUpload",
  SET_UPLOADS = "setUploads",

  SET_LINK_ERROR = "setUploadError",
  SET_LINK = "setUpload",
  SET_LINKS = "setUploads",

  SET_LICITACION_ERROR = "setLicitacionError",
  SET_LICITACION = "setLicitacion",
  SET_LICITACIONES = "setLicitaciones",

  SET_NOTICIA_ERROR = "setNoticiaError",
  SET_NOTICIA = "setNoticia",
  SET_NOTICIAS = "setNoticias",
  SET_BANCO_ERROR = "setBancoError",
  SET_BANCO = "setBanco",
  SET_BANCOS = "setBancos",




  SET_LINK_DOCUMENTO_ERROR = "setLinkDocumentoError",
  SET_LINK_DOCUMENTO = "setLinkDocumento",
  SET_LINK_DOCUMENTOS = "setLinkDocumentos",
}

export { Actions, Mutations };
